module.exports = __webpack_public_path__ + "34bc775d/img/comment-question-icon.7dd26e04.svg";